import { i18next } from '../../shared/i18n';
import { formatDate, formatTime } from '../../shared/format';

/**
 * De korte tijdsaanduidingen van deel 07: "di 15/09 · 14:30", "vandaag 13:52", "ma 14/09".
 *
 * Kort, omdat ze in een tabelkolom staan die niet mag afbreken; de volledige datum met jaar staat
 * in het detailpaneel. Weekdag en dag/maand volgen de taal van de lezer.
 */

function asDate(value: string | Date): Date {
  return value instanceof Date ? value : new Date(value);
}

/** "di 15/09". */
export function shortDay(value: string | Date): string {
  const date = asDate(value);
  if (Number.isNaN(date.getTime())) return '';
  const weekday = formatDate(date, { weekday: 'short' }).replace(/\.$/, '');
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${weekday} ${day}/${month}`;
}

/** "di 15/09 · 14:30". */
export function shortMoment(value: string | Date | null | undefined): string {
  if (!value) return '—';
  return `${shortDay(value)} · ${formatTime(value)}`;
}

function sameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/**
 * "vandaag 13:52", "gisteren 14:30", en verder terug alleen de dag ("ma 14/09"): in een spoor is
 * het uur van vorige week zelden de vraag, en het staat in de details.
 */
export function relativeMoment(value: string | Date, now = new Date()): string {
  const date = asDate(value);
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(date, now)) {
    return i18next.t('beheer.opvolging.today', { time: formatTime(date) });
  }
  if (sameDay(date, yesterday)) {
    return i18next.t('beheer.opvolging.yesterday', { time: formatTime(date) });
  }
  return shortDay(date);
}
